import React from 'react';
import { Modal, Button, Typography, Grid, Card, CardContent, FormControl } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styles from './FileTypeDownloadModal.module.scss';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { FileTypeDownloadModalProps } from './types';
import Tooltip from '@mui/material/Tooltip';

export default function FileTypeDownloadModal({
  open,
  onClose,
  handleDownloadContract,
  handleFileNameChange,
  fileName,
  fileType,
  handleFileTypeChange,
  document,
  handleDownloadHTML,
  handleDownloadDocument,
  libraryItem,
  handleDownloadLibraryHTML,
}: FileTypeDownloadModalProps) {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose} closeAfterTransition className='action-modal'>
      <Grid component='div' container className={styles.modal_container}>
        <Grid component='div' size={{ xs: 12, sm: 8, md: 6, lg: 4 }}>
          <Card>
            <CardContent sx={{ paddingBottom: '16px !important' }}>
              {((document && 'contract_generation' in document) || libraryItem) && (
                <Typography variant='h6' gutterBottom>
                  {t('dialogTitles.chooseFileType')}
                </Typography>
              )}
              <Typography>
                {(document && 'contract_generation' in document) || libraryItem
                  ? t('messages.fileTypeToDownload')
                  : t('messages.downloadingVersionMessage')}
              </Typography>

              <Grid component='div' container spacing={2} style={{ marginTop: '10px' }}>
                {((document && 'contract_generation' in document) || libraryItem) && (
                  <>
                    <Grid component='div' size={{ xs: 12 }}>
                      <FormControl sx={{ width: '100%' }}>
                        <InputLabel htmlFor='fileTypeForDownloading'>
                          {t('labels.fileType')}
                        </InputLabel>
                        <Select
                          onChange={(e: SelectChangeEvent) => {
                            handleFileTypeChange?.(e.target.value as 'pdf' | 'doc');
                          }}
                          id='fileTypeForDownloading'
                          name='fileTypeForDownloading'
                          value={fileType}
                        >
                          <MenuItem id='fileTypeDownloadModalFormatPdfMenuItem' value={'pdf'}>
                            {t('contractGeneratorDialog.formatPDF')}
                          </MenuItem>
                          {}
                          <MenuItem id='fileTypeDownloadModalFormatWordMenuItem' value={'doc'}>
                            {t('contractGeneratorDialog.formatWord')}
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid component='div' size={{ xs: 12 }}>
                      <TextField
                        label={t('labels.fileName')}
                        onChange={(e) => handleFileNameChange?.(e.target.value)}
                        name='fileName'
                        value={fileName}
                        tabIndex={-1}
                        sx={{ width: '100%' }}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
              <Grid
                component='div'
                container
                style={{
                  justifyContent: 'flex-end',
                  gap: '8px',
                  flexWrap: 'wrap',
                  marginTop: '16px',
                }}
              >
                <Button
                  id='fileTypeDownloadModalGoBackBtn'
                  variant='contained'
                  onClick={onClose}
                  className='btn-default btn-action-basic btn-cancel'
                >
                  {t('buttons.goBack')}
                </Button>
                {(document && 'contract_generation' in document) || libraryItem ? (
                  <Button
                    id='fileTypeDownloadModalDownloadBtn'
                    variant='contained'
                    onClick={libraryItem ? handleDownloadLibraryHTML : handleDownloadContract}
                    className='btn-default btn-action-basic'
                  >
                    {t('buttons.download')}
                  </Button>
                ) : (
                  <>
                    <Button
                      id='fileTypeDownloadModalDownloadOriginalDocumentBtn'
                      variant='contained'
                      onClick={handleDownloadDocument}
                      className='btn-default btn-action-basic'
                    >
                      {t('buttons.downloadOriginalDocument')}
                    </Button>
                    <Tooltip
                      title={t('buttons.editDocumentBeforeDownloading')}
                      placement='top'
                      describeChild={true}
                      arrow
                    >
                      <Button
                        id='fileTypeDownloadModalDownloadLatestVersionBtn'
                        variant='contained'
                        onClick={handleDownloadHTML}
                        className='btn-default btn-action-basic'
                      >
                        {t('buttons.downloadLatestVersion')}
                      </Button>
                    </Tooltip>
                  </>
                )}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Modal>
  );
}
